import SuburbPestControlPage from "../components/SuburbPestControlPage";
import { IPSWICH_SUBURBS } from "../data/ipswichSuburbs";

export default function PestControlOneMilePage() {
  return <SuburbPestControlPage suburb={IPSWICH_SUBURBS["one-mile"]} />;
}
